var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","background-color":"#fbfbfb"}},[_c('iframe',{ref:"mainIframe",staticStyle:{"width":"100%","height":"100%","margin":"auto"},attrs:{"id":"mainIframe","name":"mainIframe","src":"http://112.64.165.250:7070/index.html#/FoodWeekMenuView?template=self","frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62dfeb6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oldPersonHome/weekMenu.vue
// module id = null
// module chunks = 